import React from 'react';
import { useTranslation } from 'react-i18next';
import BasicTooltip from '../../Popover/BasicTooltip';
import { FirstTimeFlag } from '../../redux/firstTimeFlags/constants';
import { useFirstTimeFlag } from '../../redux/firstTimeFlags/hooks';
import s from './DywFTUETooltip.scss';
var DywFTUETooltip = React.forwardRef(function (_a, innerRef) {
    var className = _a.className;
    var t = useTranslation().t;
    var dropFlag = useFirstTimeFlag(FirstTimeFlag.IsDywUnreadTooltipNotSeen).dropFlag;
    return (React.createElement(BasicTooltip, { wrapperClassName: className, className: s['root'], withCloseButton: true, placement: "right", secondaryPlacement: "start", onClose: dropFlag, ref: innerRef },
        React.createElement("img", { alt: "", src: "https://st.deviantart.net/eclipse/global/svg/dyw-ftue-tooltip.svg", className: s['illustration'] }),
        React.createElement("div", { className: s['title'] }, t('networkBar.ftue.dyw.tooltip.title')),
        React.createElement("div", { className: s['text'] }, t('networkBar.ftue.dyw.tooltip.text'))));
});
DywFTUETooltip.displayName = 'DywFTUETooltip';
export default DywFTUETooltip;
//# sourceMappingURL=DywFTUETooltip.js.map